const getGtag = () => {
  if (typeof window === 'undefined') return null;
  if (typeof window.gtag === 'function') return window.gtag;
  // Fallback: define gtag if blocked (e.g. by ad blocker)
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  return window.gtag;
};

const logGA4Event = (eventName, eventData = {}) => {
  if (process.env.REACT_APP_ENVIRONMENT === 'LOCAL' || process.env.NODE_ENV === 'development') {
    console.log(`[GA4] ${eventName}:`, eventData);
  }
};

const GA4_ID = process.env.REACT_APP_GA4_ID || 'G-HDEGFJGY0E';

export const trackPageView = (path) => {
  const gtag = getGtag();
  if (gtag) {
    gtag('config', GA4_ID, { page_path: path });
    logGA4Event('page_view', { page_path: path });
  }
};

export const trackOtpMobileVerified = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'otp_mobile_verified');
    logGA4Event('otp_mobile_verified');
  }
};

export const trackEmailVerified = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'email_verified');
    logGA4Event('email_verified');
  }
};

export const trackGetLimitClicked = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'get_limit_clicked');
    logGA4Event('get_limit_clicked');
  }
};

export const trackCreditLimitAssigned = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'credit_limit_assigned');
    logGA4Event('credit_limit_assigned');
  }
};

export const trackGetNowClicked = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'get_now_clicked');
    logGA4Event('get_now_clicked');
  }
};

export const trackKycAadhaarVerified = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'kyc_aadhaar_verified');
    logGA4Event('kyc_aadhaar_verified');
  }
};

export const trackLoanOfferAccepted = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'loan_offer_accepted');
    logGA4Event('loan_offer_accepted');
  }
};

export const trackKfsAccepted = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'kfs_accepted');
    logGA4Event('kfs_accepted');
  }
};

export const trackBankVerificationCompleted = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'bank_verification_completed');
    logGA4Event('bank_verification_completed');
  }
};

export const trackReferencesSubmitted = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'references_submitted');
    logGA4Event('references_submitted');
  }
};

export const trackAgreementSigned = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'agreement_signed');
    logGA4Event('agreement_signed');
  }
};

export const trackLoanApplicationCompleted = () => {
  const gtag = getGtag();
  if (gtag) {
    gtag('event', 'loan_application_completed');
    logGA4Event('loan_application_completed');
  }
};
